module.exports = __webpack_public_path__ + "img/puerto-vallarta-sirena.113f521d.jpg";